var _g, _path, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1019_5574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5673 19.9754H19.0368C21.9379 19.9754 24.7203 21.1279 26.7718 23.1794C28.8232 25.2308 29.9757 28.0132 29.9757 30.9144C29.9757 33.8155 28.8232 36.5979 26.7718 38.6493C24.7203 40.7008 21.9379 41.8533 19.0368 41.8533V46.6391C12.1999 43.9043 2.62838 39.8022 2.62838 30.9144C2.62838 28.0132 3.78087 25.2308 5.83231 23.1794C7.88376 21.1279 10.6661 19.9754 13.5673 19.9754Z",
    fill: "url(#paint0_linear_1019_5574)",
    fillOpacity: 0.49
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3976 4.9808H19.7566C16.234 4.9808 12.8557 6.38015 10.3648 8.87101C7.87394 11.3619 6.47459 14.7402 6.47459 18.2628C6.47459 21.7854 7.87394 25.1637 10.3648 27.6546C12.8557 30.1455 16.234 31.5448 19.7566 31.5448V37.3557C28.0578 34.0352 39.6796 29.0544 39.6796 18.2628C39.6796 14.7402 38.2802 11.3619 35.7894 8.87101C33.2985 6.38015 29.9202 4.9808 26.3976 4.9808Z",
    fill: "#605BFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6763,
    cy: 18.5674,
    r: 2.15899,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4486,
    cy: 18.5674,
    r: 2.15899,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.221,
    cy: 18.5674,
    r: 2.15899,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1019_5574",
    x: -3.8608,
    y: 12.7353,
    width: 40.5384,
    height: 40.5384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.9304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1019_5574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1019_5574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1019_5574",
    x1: 16.302,
    y1: 19.9754,
    x2: 16.302,
    y2: 46.6391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87C0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#B298ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F55DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF866E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.b6dd2381450609139f72e4b46ffa4cbb.svg";
export { ForwardRef as ReactComponent };